function assertValue<T>(value: T | undefined, errorMessage: string): T {
    if (value === undefined) {
        throw new Error(errorMessage);
    }
    return value;
}

/**
 * Project coordinates, separate from `client.ts` on purpose: the image-URL
 * builder needs nothing but `projectId` + `dataset`, and reading them from the
 * client instance would drag `createClient` (and with it `get-it`/`rxjs`) into
 * every Client Component that builds an image URL.
 *
 * All four are `NEXT_PUBLIC_*`, so Next inlines them into the client bundle.
 */
export const projectId = assertValue(
    process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
    'Missing environment variable: NEXT_PUBLIC_SANITY_PROJECT_ID',
);
export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET || 'staging';
export const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2025-09-10';
export const studioUrl = process.env.NEXT_PUBLIC_SANITY_STUDIO_URL;
